// ui/trump-splash-logic.js: C5 pure helpers for TrumpSplash.jsx.
//
// Lives separate from the JSX file so node --test (which has no JSX
// loader) can import the constants directly. Other sibling components
// follow the same split (annotation-logic, bidding-logic, end-of-hand).

export const SUIT_SYMBOL = { S: '♠', H: '♥', D: '♦', C: '♣' };
export const SUIT_NAME   = { S: 'Spades', H: 'Hearts', D: 'Diamonds', C: 'Clubs' };

export const HOLD_MS = 300;
export const FADE_MS = 100;

/**
 * Format the maker line shown beneath the suit title. Special-cases
 * the "You" label so we say "You called it" / "You went alone"
 * rather than the grammatically incorrect "You is going alone".
 *
 * @param {{ maker_seat: number|null, caller_went_alone: boolean }} event
 * @param {Record<number, string>} seatLabels
 * @returns {string}
 */
export function makerLineFor(event, seatLabels = {}) {
  if (!event || event.maker_seat == null) return '';
  const label = seatLabels[event.maker_seat] || `Seat ${event.maker_seat}`;
  const isMe = label === 'You';
  if (event.caller_went_alone) {
    return isMe ? 'You are going alone' : `${label} is going alone`;
  }
  return `${label} called it`;
}
